import { request } from '@/api/index';
export function getList(params) {
  return request({
    url: '/api/Common/GetModuleList',
    method: 'get',
    params: params
  });
}
export function updateModule(params) {
  return request({
    url: '/api/Common/UpdateModule',
    method: 'post',
    params: params
  });
}